<template>
    <div>
        <el-tooltip
            v-model="tooltipIsOpen"
            :disabled="!invalid"
            placement="top-end">
            <template #content>
                <div class="p-2">
                    <h3 class="text-white">
                        {{ $t('core.someErrors') }}
                    </h3>
                    <p style="font-size: 0.9rem">
                        {{ errorExplanation ? errorExplanation : $t('core.someErrorsExplanation') }}
                    </p>
                    <p style="max-width: 700px">
                        <template v-for="(field, name) in errors">
                            <Badge
                                class="bg-darker mr-2 mb-2 pointer"
                                size="lg"
                                @click="scrollErrorFieldIntoView(name)">
                                {{ field }}
                            </Badge>
                        </template>
                    </p>
                    <p style="font-size: 0.8rem">
                        {{ $t('core.clickExplanation') }}
                    </p>
                </div>
            </template>
            <template #default>
                <slot>
                    <base-button
                        :class="{disabled: invalid}"
                        :disabled="invalid"
                        @mouseover="$emit('validate')"
                        @click="$emit('click', $event)">
                        {{ buttonLabel ? buttonLabel : $t('core.done') }}
                    </base-button>
                </slot>
            </template>
        </el-tooltip>
    </div>
</template>
<script>

export default {
    name: 'ValidationButton',
    props: {
        errors: {
            required: true,
            type: Object
        },
        invalid: {
            required: true,
            type: Boolean
        },
        buttonLabel: {
            type: String
        },
        errorExplanation: {
            type: String
        }
    },
    data() {
        return {
            tooltipIsOpen: false
        }
    },
    methods: {
        scrollErrorFieldIntoView(elementClass) {
            this.tooltipIsOpen = false
            const errorElement = document.querySelector(`[name="${elementClass}"]`);
            if (errorElement) {
                errorElement.scrollIntoView({behavior: 'smooth'})
            }
        }
    }
}
</script>
